import type { Climb } from '../../types/climb';

/**
 * Where the reader stands on a climb, folded into one state. In the order a
 * climb goes through them:
 *
 * - `to_try`    — nothing logged yet
 * - `attempted` — at least one go, not topped
 * - `on_sight`  — topped on sight
 * - `flash`     — topped flash
 * - `sent`      — topped, worked or nd — or with no style named at all
 *
 * Drawn by ClimbStandingIcon; read on its own wherever the state matters
 * without the picture (a filter, a count).
 */
export type ClimbStanding = 'to_try' | 'attempted' | 'on_sight' | 'flash' | 'sent';

/** The three fields of a list row the standing is read from. */
export type ClimbStandingSource = Pick<Climb, 'user_topped' | 'user_send_type' | 'user_attempts'>;

/**
 * Reads the standing off a row. A topped climb is placed by *how* it was sent;
 * one not topped by whether any attempt was logged. A send whose style was
 * never named (the dialog dismissed, or a log older than the field) is still a
 * send, so it lands on `sent` rather than nowhere.
 */
export function climbStanding(climb: ClimbStandingSource): ClimbStanding {
  if (climb.user_topped) {
    if (climb.user_send_type === 'on_sight') return 'on_sight';
    if (climb.user_send_type === 'flash') return 'flash';
    return 'sent';
  }
  return (climb.user_attempts?.length ?? 0) > 0 ? 'attempted' : 'to_try';
}
